import './Modal.scss'

import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';

import H4 from 'components/H4';
import Icon from 'components/Icon';

import { MODAL_STYLE_RESET } from 'utils/constants';

export default class PinPointModal extends React.Component {
    static propTypes = {
        className: React.PropTypes.string,
        handleClose: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        title: React.PropTypes.string,
        width: React.PropTypes.string
    };

    render() {
        let { children, className, handleClose, show, title, width } = this.props;
        return (
            <Modal isOpen={show}
                   style={MODAL_STYLE_RESET}
                   className={className}
                   contentLabel="Modal"
                   onRequestClose={this._handleClose}>
                <div role="button"
                     className="modal__close"
                     onClick={handleClose.bind(this)}>
                    <Icon icon="close" />
                </div>
                <div className={classNames('modal--inner', {'modal--inner--full-width': width === 'full', 'modal--inner--wide': width === 'wide'})}>
                    {this.props.title ? (
                        <H4 className="modal__title">
                            {title}
                        </H4>
                    ) : null}

                    <div className="modal__content">
                        {children}
                    </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Modal/index.js